import React from "react";
import { ContinueButton, ModalTemplate, SoundFx } from "@deliverr/ui-facility";
import { FormattedMessage } from "react-intl";
import { useSortationModal } from "sortation/components/SortationModal";
import { sortationDangerIconProps } from "sortation/components/SortationModal/sortationModalIconProps";
import { ZoneSkipArrivalScanModal } from "./ZoneSkipArrivalScanModal";

export interface ZoneSkipArrivalScanErrorModalProps {
  title: string;
  text: string;
  hideModalValue: ZoneSkipArrivalScanModal;
}

export const ZoneSkipArrivalScanErrorModal: React.FC<ZoneSkipArrivalScanErrorModalProps> = ({
  title,
  text,
  hideModalValue,
}) => {
  const { hideModal } = useSortationModal();
  return (
    <ModalTemplate
      title={<FormattedMessage id="sortation.zoneSkipArrivalScan.errorModalTitle" defaultMessage={title} />}
      text={<FormattedMessage id="sortation.zoneSkipArrivalScan.errorModalText" defaultMessage={text} />}
      iconProps={sortationDangerIconProps}
      soundFx={SoundFx.ERROR_FAST}
    >
      <ContinueButton block onClick={() => hideModal(hideModalValue)} />
    </ModalTemplate>
  );
};
